<script>
  import { t, locale, locales } from "./i18n";
  import { fade, fly, slide } from "svelte/transition";
  import ProduktZeile from "./Produktzeile.svelte";
  import { lha, gemeinden, abfuhren } from "./stores";

  let name;
  let AusgewählteGemeinde;
  let AnzahlHaushalte = 1;
  let ProduktZeilen = [];

  let sortOrder = ["190101", "120100", "150140", "290001", "300198", "000000"];

  $: {
    if ($abfuhren != null) {
      ProduktZeilen = [];
      if (AusgewählteGemeinde != null) {
        // Produkte berechnen
        const p = $abfuhren.filter(
          (x) => x["Vk_ID_gem"] === AusgewählteGemeinde.ID_gem
        );

        p.forEach((product) => {
          const basplus = $lha.find((x) => {
            return x.Stoff_nr === product["Vk_Stoff_nr"];
          });
          ProduktZeilen.push({
            Produkt: product["Vk_Stoff_nr"],
            Haushalte: AnzahlHaushalte,
            Frequenz: product["Frequenz"],
            BasPlus: parseFloat(basplus.BasPlus),
          });
        });

        ProduktZeilen.sort((a, b) => sortOrder.indexOf(a.Produkt) - sortOrder.indexOf(b.Produkt));
      }
      //console.log(ProduktZeilen);
    }
    // console.log(AusgewählteGemeinde);
  }
</script>

<svelte:head>
	<title>{$t("homepage.title")}</title>
</svelte:head>

<main>

  <!--
  <header style="header">
    <img
      loading="lazy"
      src="Residenz-Logo.jpg"
      alt=""
      width="1024"
      height="284"
    />
  </header>
  <p>
    <select bind:value={$locale}>
      {#each locales as l}
        <option value={l}>{l}</option>
      {/each}
    </select>
  </p>
  -->

  {#key $locale}
    <div in:fly={{ y: 100, duration: 2000 }}>


      <!--
      <div id="titleSimulator">
        <div>
          <h2>{$t("homepage.title")}</h2>
          <h2>{$t("homepage.schätzung")}</h2>
        </div>
      </div>
      -->

      <form style="text-align: center" onSubmit="return false;">
        <div>
          <span>{$t("homepage.gemeinde")}</span>
          <select bind:value={AusgewählteGemeinde}>
            {#each $gemeinden as gemeinde}
              <option value={gemeinde}>
                {gemeinde.Gemeinde}
              </option>
            {/each}
          </select>

          <span>{$t("homepage.haushalte")}</span>
          <input type="number" bind:value={AnzahlHaushalte} min="1" max="1000" />
          <!-- <input type="range" bind:value={AnzahlHaushalte} min="0" max="20" /> -->
        </div>
      </form>

      {#if AusgewählteGemeinde}
        <div style="overflow-x: auto">
          <!-- <table style="border: 2px solid black; width:100%"> -->
          <table style="min-width: 600px; border: 2px solid black; width:100%; padding: 2px 4px">
            <tr>
              <th style="text-align: left">{$t("homepage.abfallname")}</th>
              <th style="text-align: center">{$t("homepage.leerungen")}</th>
              <th style="text-align: center" colspan="2">{$t("homepage.volumen")}</th>
            </tr>
            {#each ProduktZeilen as zeile}
              <!-- <div in:fade out:fade> -->
              <ProduktZeile {...zeile} />
              <!-- </div> -->
            {/each}
          </table>
        </div>
      {/if}
    </div>
  {/key}
</main>

<style>
  #titleSimulator {
    width: 100%;
    height: 120px;
  }

  header {
    background-color: #0b8061;
  }

  main {
    margin: 0;
    padding: 0;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    font-size: 4em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
